var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 70,
    viewBox: "0 0 82 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30 64c16.569 0 30 1.343 30 3s-13.431 3-30 3c-16.569 0-30-1.343-30-3s13.431-3 30-3z",
    fill: "var(--color-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.032 14.436a.04.04 0 100-.081.04.04 0 000 .081z",
    fill: "#E6E8EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.581.641L5.018 19.82l19.293 34.79a1.345 1.345 0 00.86.656l17.48 4.264a1.347 1.347 0 001.53-.725l8.672-18.012 9.502-12.701-22.55-26.676A3.997 3.997 0 0034.58.64z",
    fill: "#F1FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.656 28.242l-.084.113-5.566 7.441-.1.135-3.753 5.015-7.416 15.407-.208.431-1.047 2.174a1.348 1.348 0 01-1.533.724l-17.48-4.266a1.345 1.345 0 01-.86-.655l-1.68-3.026-.302-.545L10.493 29.3l-.104-.187-5.071-9.144.612-.398 4.646-3.012.107-.07 9.782-6.346.617-.4L34.88.792a3.996 3.996 0 015.225.773l10.288 12.174.452.542 7.467 8.833.04.048 3.755 4.44.472.56.077.08z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M58.063 23.012l-.911 6.33-.275 1.91-.157 4.07-.013.317L55.89 56.9a1.35 1.35 0 01-1.64 1.263l-8.811-1.967-.095-.021-22.598-5.043-.415-.092-12.423-2.774.285-19.116.01-.639.085-5.786.095-6.387 9.782-6.345.618-.4c9.073.93 21.14 2.72 29.314 3.995l.453.543 7.46 8.832.053.049z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.727 57.35s0 0 0 0a1.299 1.299 0 01-1.58 1.216l-8.905-1.988-22.598-5.042-12.798-2.858.293-19.714.086-5.786.1-6.769.103-6.914c2.123-.095 5.592.131 9.732.548h0c9.337.936 22.065 2.832 30.387 4.137a1059.627 1059.627 0 017.922 1.273l.46.077.11.018-1.066 7.412-.984 6.831-.275 1.906h0v.005l-.157 4.07.05.002m-.88 21.577l.05.002.83-21.58m-.88 21.578l.83-21.58.05.002m-.88 21.578l.88-21.578",
    fill: "#fff",
    stroke: "#E0E0E0",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.817 27.452l-4.779 2.343-24.387 11.959-22.476-18.573-4.543-3.76-.613.398 5.071 9.144-.294 19.755 12.838 2.866 1.678 3.026a1.344 1.344 0 00.86.656l17.48 4.264a1.348 1.348 0 001.53-.725l1.046-2.173 8.906 1.988a1.348 1.348 0 001.64-1.263l.83-21.58 5.668-7.572.015-.191-.47-.562z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.018 19.819L3.002 54.33a1.347 1.347 0 001.053 1.394l53.53 11.886a1.349 1.349 0 001.632-1.207l3.137-38.312-29.703 14.566-27.633-22.84z",
    fill: "#F1FBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.371 55.121l27.81-17.155a2.042 2.042 0 012.6.407L58.672 67.4c.09.104.135.03 0 0L3.371 55.121c-.158-.035-.138.083 0 0z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57 55.093L31.093 38.47a2.159 2.159 0 012.744.432l24.667 28.364a.298.298 0 01-.289.485L3.66 55.637a.296.296 0 01-.09-.544z",
    fill: "#F1FBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.065 43.393l-14.1 13.987a.938.938 0 01-1.326-.005l-6.71-6.764a.938.938 0 01.006-1.325l.666-.66a.938.938 0 011.326.005l5.388 5.432 12.77-12.666a.937.937 0 011.325.005l.66.666a.938.938 0 01-.005 1.325z",
    fill: "#49BC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.75ae44ef444aaeeeed4c9d4f594c25b8.svg";
export { ForwardRef as ReactComponent };